import {useDarkMode} from "../../contexts/darkModeContext";

const PerformanceScoreRing = ({ score = 0, size = 64 }) => {
    const totalBars = 12;
    
    const { darkMode } = useDarkMode();

    const clampedScore = Math.max(0, Math.min(score, totalBars));
    const filledBars = Math.floor(clampedScore);
    const partialFill = clampedScore - filledBars;
    
    const getColorClass = () => {
        const percent = clampedScore / totalBars;

        if (percent >= 0.75) return "text-green-600";
        if (percent >= 0.4) return "text-yellow-600";
        return "text-red-600";
    };
    
    const activeColor = getColorClass();
    const inactiveColor = `${darkMode ? 'text-neutral-700' : 'text-gray-200'}`;

    return (
        <div
          className="relative flex items-center justify-center"
          style={{ width: size, height: size }}
        >
          <svg
            className="shrink-0"
            width={size}
            height={size}
            viewBox="0 0 64 64"
          >
            <g transform="translate(32,32)">
              {Array.from({ length: totalBars }).map((_, i) => {
                const rotation = i * (360 / totalBars);

                const isFull = i < filledBars;
                const isPartial = i === filledBars && partialFill > 0;

                let height = 14;
                let y = -28;

                if (isPartial) {
                  height = 14 * partialFill;
                  y = -28 + (14 - height);
                }
    
                return (
                  <rect
                    key={i}
                    x="-3"
                    y={isFull ? "-28" : y}
                    width="6"
                    height={isFull ? "14" : (isPartial ? height : "14")}
                    rx="3"
                    transform={`rotate(${rotation})`}
                    className={isFull || isPartial ? activeColor : inactiveColor}
                    fill="currentColor"
                  />
                );
              })}
            </g>
          </svg>
    
          {/* Optional center label */}
          <span className="absolute text-xxs font-semibold text-gray-500">
            {clampedScore.toFixed(1)}
          </span>
        </div>
    );
};

export default PerformanceScoreRing;
